import { Injectable, inject } from '@angular/core';
import {AnalyticsService} from "../analytics/analytics.service";

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  private analyticsService: AnalyticsService = inject(AnalyticsService);


  canShare(): boolean {
    return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
  }

  share(xploreId: number, title: string, text: string, url: string): void {

    this.analyticsService.addShareAction(xploreId);

    if (!this.canShare()) {
      return;
    }

    navigator.share({
      title: title,
      text: text,
      url: url
    }).then(() => {})
      .catch(() => {});
  }

}
